import { render, staticRenderFns } from "./MarketPromoModal.vue?vue&type=template&id=40167e62&scoped=true&"
import script from "./MarketPromoModal.vue?vue&type=script&lang=js&"
export * from "./MarketPromoModal.vue?vue&type=script&lang=js&"
import style0 from "./MarketPromoModal.vue?vue&type=style&index=0&id=40167e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40167e62",
  null
  
)

export default component.exports